import { lowerFirst } from '@sonar-software/sonar-ts-lib';
import { PardotCompletionAction } from './PardotCompletionAction';
import { PeriscopeV3PaginatedList } from '..';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import React, { useCallback } from 'react';
import { usePeriscopeActions, useQueryResource } from '@hooks';
export const PardotCompletionActionList = ({ parentIndex, uri }) => {
    const { openPeriscope } = usePeriscopeActions();
    const { loading, queryParams, resource, updateParams } = useQueryResource({
        defaultParams: keyPaginationDefaultQueryParams,
        fallbackParams: keyPaginationFallbackQueryParams,
        uri
    });
    const renderCompletionAction = useCallback((completionAction, index) => {
        const handleCompletionActionClick = (clickedField) => {
            const { displayName, sonarObjectId, sonarObjectType } = clickedField;
            const completionActionReferenceType = lowerFirst(sonarObjectType);
            if (sonarObjectType) {
                openPeriscope({
                    id: sonarObjectId,
                    name: displayName,
                    openedFromIndex: parentIndex,
                    type: completionActionReferenceType
                });
            }
        };
        return (React.createElement(PardotCompletionAction, { entity: completionAction, key: `${completionAction.displayName}-${index}`, onCompletionActionClick: handleCompletionActionClick }));
    }, [openPeriscope, parentIndex]);
    return (React.createElement(PeriscopeV3PaginatedList, { loading: loading, onChange: updateParams, queryParams: queryParams, renderListItem: renderCompletionAction, resource: resource }));
};
